module.exports = __webpack_public_path__ + "static/img/icon-design.a13ff38c.png";